module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-icon', {
    staticClass: "cursor-pointer",
    attrs: {
      "title": "Update"
    }
  }, [_vm._v("edit")]), _vm._v(" \n        "), _c('span', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "1.3rem!important"
    }
  }, [_vm._v("Edit Distribution")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    staticStyle: {
      "min-width": "95px"
    },
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "2"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label font-weight-bold mb-0"
  }, [_vm._v("Amount: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "disabled": _vm.resetEdit,
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.editData.amount),
      callback: function($$v) {
        _vm.$set(_vm.editData, "amount", $$v)
      },
      expression: "editData.amount"
    }
  }), _vm._v(" "), (this.editData.editedCheck) ? _c('v-btn', {
    staticClass: "warning ml-2",
    on: {
      "click": _vm.resetEditedMonth
    }
  }, [_vm._v("Reset")]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    staticStyle: {
      "min-width": "95px"
    },
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "2"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label font-weight-bold mb-0"
  }, [_vm._v("Recorded:")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "8",
      "sm": "8"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "",
      "color": "secondary",
      "true-value": true,
      "false-value": false,
      "hide-details": ""
    },
    model: {
      value: (_vm.editData.recordCheck),
      callback: function($$v) {
        _vm.$set(_vm.editData, "recordCheck", $$v)
      },
      expression: "editData.recordCheck"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    staticStyle: {
      "max-width": "95px"
    },
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label font-weight-bold mb-0"
  }, [_vm._v("Remarks : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "placeholder": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.editData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.editData, "remarks", $$v)
      },
      expression: "editData.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Timestamp")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Recorded")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Remark")])])]), _vm._v(" "), _c('tbody', [(!_vm.editItem.editHistory.length) ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("Empty List")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editItem.editHistory), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(_vm.formatTime(item.timestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.recorded ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.remarks || ''))])])
        })], 2)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": !_vm.editData.amount && !_vm.resetEdit,
      "text": ""
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc7a1b32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/MasterLists/DistributionEditModal.vue
// module id = 2280
// module chunks = 0